import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { GlobalContext } from './interfaces/GlobalContext/GlobalContext';
import './services/I18nProvider/config';
// import reportWebVitals from './reportWebVitals';
import { GroupBase } from 'react-select';
import track from 'react-tracking';
import TrackingMeta from './interfaces/Tracking/TrackingMeta';
import environment from "./services/EnvironmentProvider/EnvironmentProvider";
import I18nProvider from "./services/I18nProvider/I18nProvider";
import localStorageProvider from './services/LocalStorageProvider/LocalStorageProvider';
import logger from "./services/Logger/Logger";
import loginProvider from './services/LoginProvider/LoginProvider';
import requestProvider from './services/RequestProvider/RequestProvider';
import SessionStorageProvider from './services/SessionStorageProvider/SessionStorageProvider';
import TrackingHandler from './services/TrackingHandler/TrackingHandler';
import utilityProvider from './services/UtilityProvider/UtilityProvider';
import globalStates from './services/GlobalStates/GlobalStates';

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Juris?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        etCommerce?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _etracker?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        et_ClickEvent?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        et_AuthenticationFailureEvent?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        et_AuthenticationSuccessEvent?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        et_DownloadEvent?: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        DY?: any;
    }

    interface HTMLElement {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        instance?: any;
    }
}

declare module 'react-select/dist/declarations/src/Select' {
    export interface Props<
        Option,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        IsMulti extends boolean,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Group extends GroupBase<Option>
        > {
        maxLength?: number;
        selectedIsValid?: boolean;
        isLoggedIn?: boolean;
        availableText?: string;
        notAvailableText?: string;
    }
}

// Initialisierung nach i18n src\services\I18nProvider\config.ts
export default function createEntryPoint(selector: string, type: string) {
    const rootElements = document.querySelectorAll(selector) as NodeListOf<HTMLElement>;
    rootElements.forEach((rootElement) => {
        const app = ReactDOM.createRoot(
            rootElement
        );
        utilityProvider.setRootElement(rootElement);

        const TrackedApp = track(
            { /*type*/ },
            {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                dispatch: (data: Record<string, any>) => {
                    console.log(data);
                    const trackingMeta = {...data.trackingMeta} as TrackingMeta;
                    delete data.trackingMeta;

                    TrackingHandler.handleTracking(trackingMeta, data);
                }
            }
        )(
            () => {
                return <React.StrictMode>
                    <GlobalContext.Provider value={{
                        localStorageProvider: localStorageProvider,
                        sessionStorageProvider: new SessionStorageProvider({}),
                        environment: environment,
                        logger: logger,
                        requestProvider: requestProvider,
                        i18nProvider: new I18nProvider({}),
                        utilityProvider: utilityProvider,
                        loginProvider: loginProvider,
                        globalStates: globalStates,
                    }}>            
                        <App type={type}
                            magicNumber={rootElement.dataset.productId}
                            campaignId={rootElement.dataset.campaignId}
                            buttonTitle={rootElement.dataset.buttonTitle}
                            buttonClass={rootElement.dataset.buttonClass}
                            fsResources={rootElement.dataset.fsResources}
                            directPurchase={rootElement.dataset.directPurchase}
                            showBuyButton={rootElement.dataset.showBuyButton} />
                    </GlobalContext.Provider>
                </React.StrictMode>
            }
        )

        app.render(<TrackedApp />);
    });
}

window.Juris = window.Juris || {};
window.Juris.createEntryPoint = createEntryPoint;

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
